import { memo, ReactElement } from 'react';

import { CheckIcon, Cross1Icon } from '@radix-ui/react-icons';
import { ReactComponent as WarningIcon } from 'assets/icons/icon_warning.svg';
import { ReactComponent as ErrorIcon } from 'assets/icons/icon-error.svg';

import { BaseText } from 'styles/__typography';
import * as S from './styles';
import theme from 'styles/theme';
import { FlexCol } from 'styles/__layout';

interface Props {
  message: string | ReactElement;
  title?: string | ReactElement;
  variant: 'error' | 'success' | 'info' | 'warning';
  onClose?: () => void;
  [key: string]: any;
}

const colorMap = {
  error: theme.colors.reds[2],
  success: theme.colors.greens[2],
  info: theme.colors.blues[2],
  warning: theme.colors.oranges[2],
};

const iconMap = {
  error: <ErrorIcon width={28} />,
  success: <CheckIcon />,
  warning: <WarningIcon width={28} />,
};

export const Alert = memo(({ message, variant = 'success', onClose, title, ...props }: Props) => {
  return (
    <S.Wrapper variant={variant} borderRadius={2} alignItems="center" {...props}>
      {iconMap[variant]}
      <FlexCol ml={3} width="100%">
        {title && (
          <BaseText color="inherit" fontSize={1} fontWeight={3} lineHeight={1.8}>
            {title}
          </BaseText>
        )}
        <BaseText color="inherit" fontSize={1} lineHeight={1.45}>
          {message}
        </BaseText>
      </FlexCol>
      {onClose && (
        <S.BtnWrapper onClick={() => onClose?.()} variant="transparent" height={20} width={20}>
          <Cross1Icon color={colorMap[variant]} />
        </S.BtnWrapper>
      )}
    </S.Wrapper>
  );
});
